import React from "react"
import styled from "@emotion/styled"
import cx from "classnames"
import { mq } from "../mixins"
import * as Mixins from '../mixins';

import Button from "../Button/button"

import "./productImage.scss"

const ProductImage = props => {
  const Headline = styled.h2`
    color: ${props.color_theme === "light" ? "#000;" : "#fff;"};
    &.no_product_platform{      
      text-align:left;
      ${mq("lgMobile")} {
        text-align:center;
      }
    }
  `

  const ProductImageBlock = styled.div`
    background: ${props.transparent_bg === true ? 'transparent' : props.color_theme === "light" ? "#fff;" : "#212121;"};
  `
  const Description = styled.div`
    color: ${props.color_theme === "light" ? "#616161;" : "#fff"};
    &.no_product_platform{
      ${Mixins.dFlex}
      ${Mixins.flexDirection('column')}
      ${Mixins.alignItems('center')}
    }
      ol{
        margin-left: 0px;
        li{
          &:before {
            font-family: "Saira Condensed", sans-serif;
            font-size:26px;
            ${mq("tablet")} {
              font-size:32px;
            }
          }
        }
      }
  `

  const Promotion = styled.p`
    color: ${props.color_theme === "light" ? "#000;" : "#fff"};
  `

  const Disclaimer = styled.p`
    color: ${props.color_theme === "light" ? "#9E9E9E;" : "#fff"};
  `

  let productPlatform = props.product_images[0].product_platform

  // useEffect(() => {
  //   document.querySelector(
  //     ".product-image-block__body-copy--container"
  //   ).style.height = `${
  //     document.querySelector(
  //       `.product-image-block__body-copy--${productPlatform}`
  //     ).clientHeight
  //   }px`
  // })

  const handleClick = e => {
    e.preventDefault()
    const target = e.target.innerHTML.toLowerCase()

    if (target !== productPlatform) {
      document
        .querySelector(`.product-image-block__image--${target}`)
        .setAttribute("style", "opacity: 1; height: auto; margin-top: 0px;")

      // document
      //   .querySelector(`.product-image-block__body-copy--${target}`)
      //   .setAttribute("style", "opacity: 1; height: auto; margin-top: 0px;")

      document
        .querySelector(`.product-image-block__tabs--${target}`)
        .classList.add("active")

      document
        .querySelector(`.product-image-block__tabs--${productPlatform}`)
        .classList.remove("active")

      document
        .querySelector(`.product-image-block__body-copy--${target}`)
        .classList.add("active")

      document
        .querySelector(`.product-image-block__body-copy--${productPlatform}`)
        .classList.remove("active")

      document
        .querySelector(`.product-image-block__image--${target}`)
        .classList.add("active")

      document
        .querySelector(`.product-image-block__image--${productPlatform}`)
        .classList.remove("active")

      document
        .querySelector(`.product-image-block__image--${productPlatform}`)
        .setAttribute("style", "opacity: 0; height: 0; margin-top: 0;")

      // document
      //   .querySelector(`.product-image-block__body-copy--${productPlatform}`)
      //   .setAttribute("style", "opacity: 0; height: 0; margin-top: 0;")

      // document.querySelector(
      //   ".product-image-block__body-copy--container"
      // ).style.height = `${
      //   document.querySelector(`.product-image-block__body-copy--${target}`)
      //     .clientHeight
      // }px`

      productPlatform = props.product_images.filter(
        x => x.product_platform === target
      )[0].product_platform
    } else {
      return false
    }
  }
  return (
    <ProductImageBlock className="product-image-block">
      <div
        className={`container ${props.component_alignment
          .split(" ")
          .join("_")}`}
      >
        <div className="product-image-block__content">
          <Headline 
            className={cx("headline", {no_product_platform : props.product_images.length === 1 && props.product_images[0].product_platform === 'none'})}
          > {props.headline} </Headline>
          {props.product_images.length > 1 && (
            <div className="product-image-block__tabs">
              {props.product_images.map((platforms, index) => (
                <a
                  key={`${index}-tabs-${platforms.product_platform}`}
                  onClick={handleClick}
                  className={`product-image-block__tabs--${
                    platforms.product_platform
                  } 
                    ${
                      platforms.product_platform === productPlatform
                        ? "active"
                        : ""
                    }`}
                >
                  {platforms.product_platform}
                </a>
              ))}
            </div>
          )}
          <div className="product-image-block__body-copy--container">
            {props.product_images.map((platforms, index) => (
              <div
                key={`${index}-${platforms.product_platform}`}
                className={`product-image-block__body-copy product-image-block__body-copy--${
                  platforms.product_platform
                } ${
                  platforms.product_platform === productPlatform ? "active" : ""
                }`}
              >
                <Description
                  key={`${index}-${platforms.body_copy}`}
                  dangerouslySetInnerHTML={{
                    __html: platforms.body_copy,
                  }}
                  className={cx({no_product_platform : props.product_images.length === 1 && platforms.product_platform === 'none'})}
                />
                {platforms.reference && (
                  <div
                    className={
                      platforms.reference.length > 0 &&
                      platforms.reference[0].__typename ===
                        "Contentstack_button"
                        ? "button__container"
                        : "reference__containers"
                    }
                  >
                    {platforms.reference.map((data, index) => {
                      switch (data.__typename) {
                        case "Contentstack_app_icon":
                          return (
                            <div
                              className="hero__apps-icon"
                              key={`${index}-${data.badge[0].badge.url}`}
                            >
                              <a
                                target="_blank"
                                rel="noopener noreferrer"
                                href={data.app_url.href}
                              >
                                <img
                                  src={data.badge[0].badge.url}
                                  alt="App Store icon"
                                />
                              </a>
                            </div>
                          )
                        case "Contentstack_button":
                          return (
                            <Button
                              key={`${index}-${data.button_text}`}
                              button_link={data.button_link.href}
                              button_link_type={data.button_link_type}
                              button_text={data.button_text}
                              button_color={data.button_color}
                              button_type={data.button_type}
                              className={
                                data.button_type === "square button" &&
                                "button__sign-up"
                              }
                              color_theme={props.color_theme}
                              text_color={data.text_color}
                            />
                          )
                        default:
                          return null
                      }
                    })}
                  </div>
                )}
              </div>
            ))}
          </div>
          {props.promotional_text !== null &&
            props.promotional_text !== undefined &&
            props.promotional_text[0] && (
              <>
                <Promotion className="text-block__promotion">
                  {props.promotional_text[0].mkt_copy}
                  <br />
                  {props.promotional_text[0].subhead}
                </Promotion>
                <Disclaimer className="disclaimer">
                  {props.promotional_text[0].legal_copy}
                </Disclaimer>
              </>
            )}
        </div>
        <div>
          {props.product_images.map((x, index) => {
            switch (x.__typename) {
              case "Contentstack_product_image":
                return (
                  <div
                    key={`${index}-${x.product_image.url}`}
                    className={`product-image-block__image product-image-block__image--${
                      x.product_platform
                    } ${
                      x.product_platform === productPlatform ? `active` : ``
                    }`}
                  >
                    <img
                      className="product__image"
                      src={x.product_image.url}
                      alt={`${x.product_platform} Product Shot`}
                    />
                  </div>
                )

              case "Contentstack_product_retail_component":
                return (
                  <div
                    key={`${index}-retail`}
                    className={`product-image-block__image product-image-block__image--${
                      x.product_platform
                    } ${
                      x.product_platform === productPlatform ? `active` : ``
                    }`}
                  >
                    <div className="product-image-block__image--retail-container">
                      {x.product_retail.map((retail, index) => (
                        <div
                          className="retail"
                          key={`${index}-${retail.retail_address}`}
                        >
                          <img
                            className="retail__image"
                            src={x.retail_image.url}
                            alt="Location Icon"
                          />
                          <a
                            href={retail.retail_name.href}
                            target="_blank"
                            className="large-link"
                          >
                            {retail.retail_name.title}
                          </a>
                          <p>{retail.retail_address}</p>
                        </div>
                      ))}
                    </div>
                  </div>
                )
              default:
                return null
            }
          })}
        </div>
      </div>
    </ProductImageBlock>
  )
}

export default ProductImage
